module.exports = __webpack_public_path__ + "img/triangle4yellow.ebbcb7ec.png";